import React, { useMemo } from 'react';
import { Typography } from '@mui/material';
import { round } from 'lodash';

import styles from './EnergyCell.module.scss';

type Props = {
  energy: number | null | undefined;
  loading?: boolean;
};

const UNIT_LABEL = 'kJ';

const EnergyCell: React.FC<Props> = ({ energy, loading }) => {
  const loadingOrError = useMemo(() => (!energy && energy !== 0) || loading, [energy, loading]);

  const roundedEnergy = useMemo(() => {
    const value = energy || 0;
    return round(value, value < 10 ? 1 : 0);
  }, [energy]);

  return (
    <div className={styles.wrapper} data-testid="forecast-table-energy-cell">
      {loadingOrError ? (
        <div data-testid="forecast-table-energy-empty-content" className={styles.emptyContent}>
          <Typography
            className={styles.percent}
            color="text.light"
            component="p"
            data-testid="forecast-table-energy-empty"
            variant="caption1"
          >
            --{UNIT_LABEL}
          </Typography>
        </div>
      ) : (
        <Typography
          className={styles.content}
          component="span"
          data-testid="forecast-table-energy-content"
        >
          <Typography
            className={styles.energy}
            color="text.primary"
            component="h3"
            data-testid="forecast-table-energy"
            variant="subHeadline"
          >
            {roundedEnergy}
          </Typography>
          <Typography
            className={styles.percent}
            color="text.primary"
            component="p"
            data-testid="forecast-table-energy-percent"
            variant="caption1"
          >
            {UNIT_LABEL}
          </Typography>
        </Typography>
      )}
    </div>
  );
};

export default EnergyCell;
